/**
 * IMPORTS
 */

import { useMutation, useQueryClient } from "@tanstack/react-query";

// store / zustand
import { useStoreZustandUserAuth } from "@/store-zustand/user-auth";

// domain / caso de uso

// domain / caso de uso

// typings
import {
  ICreateUsuarioClientePayload,
  ICreateUsuarioClienteResponse,
} from "@/hooks/usuários/criar-usuarios-clientes/interface";

import { handleCreateUsuariosClientes } from "@/domain/use-cases/cutomers";
import { notifyAlert } from "@/utils/notify-messages";

export function useCriarUsuarioCliente() {
  const queryClient = useQueryClient(); // ← necessário para invalidar a query
  const { token } = useStoreZustandUserAuth();

  const mutation = useMutation<ICreateUsuarioClienteResponse, Error, ICreateUsuarioClientePayload>({
    mutationFn: async (payload) => {
      return await handleCreateUsuariosClientes(token!, payload);
    },
    async onSuccess(data: any) {
      if (data?.errors?.message) {
        notifyAlert(data.errors?.message ?? "Erro inesperado ao solicitar remessa!");
        return;
      }
      await queryClient.invalidateQueries({ queryKey: ["clientes"] });
      await queryClient.invalidateQueries({ queryKey: ["usuario-clientes"] });
    },
  });

  return {
    criarUsuarioCliente: mutation.mutate,
    criarUsuarioClienteAsync: mutation.mutateAsync,
    isLoading: mutation.isPending,
    isError: mutation.isError,
    error: mutation.error,
    data: mutation.data,
    isSuccess: mutation.isSuccess,
  };
}
